import {
  QueueApiResponse,
  QuizQueueActions,
  QuizQueueByItemFilter,
  QuizQueueByItemParams,
  QuizQueueByItemResponse,
  QuizQueueQueryResponse,
} from '../../../types/queues';
import { AxiosGetType } from '../../../context/FetchProvider';
import { AxiosPostType } from '../../../context/FetchProvider';
import {
  QuizQueueItems,
  QuizQueueResponse,
} from '@elsevier-health/osmosis-shared/types/queue';

export const QUEUE_REFETCH_INTERVAL = 60 * 1000 * 5; // 5 minutes

/**
 * Fetch the quiz queues on the frontend.
 */
export async function fetchQuizQueues(
  get: AxiosGetType,
): Promise<QuizQueueQueryResponse> {
  const res = await get<QueueApiResponse>('/v0/queues', {
    params: {
      types: ['flashcards', 'questions', 'spacedRepetition'],
    },
  });

  const flashcards = res.data.queues?.flashcards;
  const questions = res.data.queues?.questions;
  const spacedRepetition = res.data.queues?.spacedRepetition;

  return {
    flashcards,
    questions,
    spacedRepetition,
  };
}

/**
 * Retrieves quiz queue items based on the specified type.
 */
export const fetchQuizQueueByTime = async (
  post: AxiosPostType,
  data: { type: 'fc' | 'questions' },
) => {
  const res = await post<
    { groups: QuizQueueItems<QuizQueueResponse> },
    { type: 'fc' | 'questions' }
  >('/getQuizQueue', data);

  return res.data.groups;
};

/**
 * Executes a bulk action queue request.
 */
export const bulkActionQueue = async (
  post: AxiosPostType,
  data: {
    action: QuizQueueActions;
    type: 'fc' | 'ques';
    set: string;
  },
) => {
  return post('/bulkQueueAction', data);
};

/**
 * Fetches the quiz queue by item.
 */
export const fetchQuizQueueByItem = async (
  post: AxiosPostType,
  data: {
    type: 'fc' | 'ques';
    startRow: number;
    rowCount: number;
    filter: QuizQueueByItemFilter[];
  },
): Promise<QuizQueueByItemResponse> => {
  const res = await post<QuizQueueByItemResponse, QuizQueueByItemParams>(
    '/filterQueueItems',
    data,
  );

  return res.data;
};

/**
 * Removes an item from the quiz queue.
 */
export const removeQuizQueueByItem = async (
  post: AxiosPostType,
  data: {
    type: 'fc' | 'ques';
    nodeID: number;
    days: number;
  },
) => {
  return post('/removeFromQueue', data);
};
